import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  animatedVideoIcon,
  socialMediaVideoIcon,
  youtubeVideoIcon,
  podcastVideoIcon,
  tutorialVideoIcon,
} from "../../../../assets/icons/serviceIcon/index";

const items = [
  {
    name: "Training & Internal Communication Videos",
    text: "Edit videos that explain processes, onboard teams, or share internal updates in a way that’s clear, consistent, and easy to understand.",
  },
  {
    name: "Company Profile & Brand Films",
    text: "Create polished video presentations that introduce your business, highlight your values, and build trust with clients, investors, or partners.",
  },
  {
    name: "Event & Presentation Edits",
    text: "Turn raw event footage or corporate presentations into clean, concise videos - ready to share across platforms or archive for future use.",
  },
];

const otherService = [
  {
    icon: socialMediaVideoIcon,
    name: "Social Media Videos",
    des: "From raw videos to scroll-ready IG Reels and YT Shorts",
    path: "/social-media-videos",
  },
  {
    icon: youtubeVideoIcon,
    name: "YouTube Video Editing",
    des: "Long-form YouTube videos with clean cuts, flow, and branding.",
    path: "/youtube-video-editing",
  },
  {
    icon: animatedVideoIcon,
    name: "Animated Videos",
    des: "Engaging animated videos that simplify ideas and grab attention.",
    path: "/animated-videos",
  },
  {
    icon: podcastVideoIcon,
    name: "Podcast & Interview Editing",
    des: "Clean edits, smooth flow, and visuals that make content shine.",
    path: "/podcast-and-interview-editing",
  },
  {
    icon: tutorialVideoIcon,
    name: "Explainer & Tutorial Videos",
    des: "Break down complex ideas into simple, easy-to-follow video explanations.",
    path: "/explainer-tutorial-video",
  },
];
const CorporateVideo = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading=" Videos"
        description="Your business deserves videos that feel professional, look sharp, and communicate clearly. We edit and produce corporate videos that are tailored for internal use, brand presence, or client-facing communication."
        heading="Corporate & Business"
      />
      <NewCommonServiceForm title="Corporate & Business Videos" items={items} />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default CorporateVideo;
